<ng-container *ngIf="!hide">
    <ng-container *ngFor="let item of subNavigation$ | async">
        <div *ngIf="item === (activeSubNavigation$ | async)" class="active-tab">
            {{ item.data.label | i18next }}
        </div>
        <div *ngIf="item !== (activeSubNavigation$ | async)" (click)="onChangeTab(item)">
            {{ item.data.label | i18next }}
        </div>
    </ng-container>
</ng-container>
